import { parseYupValidationErrors } from 'services/yup';

import {
  addPatientSsuValidationSchema,
  addValidationSchema,
  medicalRecordNumberValidationSchema
} from './validationSchema';

export const VALIDATION_FAILED = 'VALIDATION_FAILED';

export function validateAddPatientInfo(info, ssu, medicalRecordNumber) {
  return new Promise(function(resolve, reject) {
    const patientStipendFieldsRequired = ssu?.site?.patientStipendFieldsRequired;
    const ssuResult = validateSsu(ssu);
    const medicalRecordNumberResult = validateMedicalRecordNumber(medicalRecordNumber, patientStipendFieldsRequired);
    const result = validatePatientInfo(info, false, patientStipendFieldsRequired);

    if (!ssuResult.data || !medicalRecordNumberResult.data || !result.data) {
      reject({
        status: 'VALIDATION_FAILED',
        validationMessages: {
          ...ssuResult.validationMessages,
          ...medicalRecordNumberResult.validationMessages,
          ...result.validationMessages
        }
      });
      return;
    }

    resolve();
  });
}

export function validateEditPatientInfo(info, originalPID, patientStipendFieldsRequired, existingSsn) {
  return new Promise(function(resolve, reject) {
    const result = validatePatientInfo(info, true, patientStipendFieldsRequired, existingSsn, originalPID);

    if (!result.data) {
      reject({
        status: 'VALIDATION_FAILED',
        validationMessages: result.validationMessages
      });
      return;
    }

    resolve();
  });
}

function validateSsu(ssu) {
  try {
    return {
      data: addPatientSsuValidationSchema.validateSync(ssu, { abortEarly: false })
    };
  } catch (error) {
    return {
      validationMessages: parseYupValidationErrors(error.inner)
    };
  }
}

function validateMedicalRecordNumber(medicalRecordNumber, patientStipendFieldsRequired) {
  try {
    return {
      data: medicalRecordNumberValidationSchema.validateSync(
        { medicalRecordNumber },
        {
          abortEarly: false,
          context: {
            patientStipendFieldsRequired
          }
        }
      )
    };
  } catch (error) {
    return {
      validationMessages: parseYupValidationErrors(error.inner)
    };
  }
}

function validatePatientInfo(info, isEdit, patientStipendFieldsRequired, existingSsn, originalPID) {
  const { cardId, paymentType } = info;
  const financialFieldsRequired = cardId || paymentType || patientStipendFieldsRequired;

  try {
    return {
      data: addValidationSchema.validateSync(info, {
        abortEarly: false,
        context: {
          isEdit,
          existingSsn,
          originalPID,
          financialFieldsRequired
        }
      })
    };
  } catch (error) {
    return {
      validationMessages: parseYupValidationErrors(error.inner)
    };
  }
}
